import { useEffect, useState, useCallback } from "react";
import "./index.css";
import Autocomplete from "react-google-autocomplete";
import axios from "../axios";
import Faq from "react-faq-component";
import { useNavigate, useLocation } from "react-router-dom";
import { genderConversion, modeOfTutionconversion, citysList } from "../constants/form-templates";
import { logEvent } from "../analytics";
import { EVENTS, FaqData, Categories } from "../constants";
import ParentsReviewComponent from "../components/ParentsReview/ParentsReview";
import SkilledTutorsComponent from "../components/SkilledTutors/SkilledTutors";
import PlatformReviewComponent from "../components/PlatformReviews/platform-review";
import Footer from "../components/Footer";

const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const styles = {
  bgColor: "white",
  titleTextColor: "Black",
  rowTitleColor: "Black",
  rowContentColor: "grey",
  arrowColor: "black",
};

const config = {
  animate: true,
  // arrowIcon: "V",
  tabFocus: true,
  expandIcon: "+",
  collapseIcon: "-",
};

export default function NeedATutor() {
  const [currentStep, setCurrentStep] = useState(0);
  const [apiData, setApiData] = useState([]);
  const [smsOtpVerification, setSmsOtpVerification] = useState(false);

  const [otp, setOtp] = useState();
  const [showResendOtp, setShowResendOtp] = useState(false);
  const [verificationProcess, setVerificationProcess] = useState(false);
  const [showTC, setShowTC] = useState(false);
  const [enableSubmitButton, setEnableSubmitButton] = useState(false);

  const [Form, setForm] = useState([
    {
      viewed: true,
      filled: false,
      fields: [
        {
          type: "dropDown",
          open: true,
          name: "Choose Study Area",
          placeHolder: "Choose Study Area",
          options: [
            "school education",
            "Learn Language",
            "Curricular",
            "Competitive Exams",
            // 'Intermediate Courses',
            // 'Abroad Exams',
            "IT Courses",
            "Special Kids (ADHD /ADD /AUTISM)",
          ],
          value: "",
        },
      ],
    },
    {
      viewed: false,
      filled: false,
      fields: [
        {
          type: "dropDown",
          open: false,
          name: "Prefered Tutor Gender",
          placeHolder: "Require Male/Female Tutor ?",
          options: ["I need only Male Tutor", "I need only Female Tutor", "Either Male or Female "],
          value: "",
        },
        {
          type: "dropDown",
          open: false,
          name: "Mode of tuition",
          placeHolder: "Enter Your Mode of tuition",
          options: ["Looking for Online Tutor", "Looking for Home Tutor", "Either Home/Online Tutor"],
          value: "",
        },
        {
          type: "dropDown",
          open: false,
          name: "How many days in a week you need tuition?",
          placeHolder: "Select days per week ",
          options: [
            "1 Day a week",
            "2 Days a week",
            "3 Days a week",
            "4 Days a week",
            "5 Days a week",
            "6 Days a week",
          ],
          value: "",
        },
        {
          type: "dropDown",
          open: false,
          name: "When you would like to start ?",
          placeHolder: "Select Starting day",
          options: ["Immediately", "In Few Days", "In A Week", "In 10 Days", "In This Month", "Next Month"],
          value: "",
        },
        {
          type: "dropDown",
          open: false,
          name: "When State you are from ?",
          placeHolder: "Select State",
          options: citysList,
          value: "",
        },
        {
          type: "address",
          name: "Location",
          placeHolder: "Search for Apartment / Building / Society / locality….",
          value: "",
        },
      ],
    },
    {
      viewed: false,
      filled: false,
      fields: [
        {
          type: "text",
          name: "First Name",
          placeHolder: "Enter Your First Name",
          value: "",
        },
        {
          type: "text",
          name: "Last Name",
          placeHolder: "Enter Your Last Name",
          value: "",
        },
        {
          type: "dropDown",
          open: true,
          name: " Your Gender",
          placeHolder: "Select Your Gender",
          options: ["male", "female"],
          value: "",
        },
        {
          type: "tel",
          name: "Mobile",
          placeHolder: "Enter Your 10 Digit Mobile Number",
          value: "",
        },
        {
          type: "email",
          name: "Email",
          placeHolder: "Enter Your Email",
          value: "",
        },
        {
          type: "dropDown",
          open: false,
          name: "From where you got to know about us",
          placeHolder: "From where you got to know about us",
          options: ["Instagram", "Facebook", "LinkedIn", "Reference", "Google", "Youtube"],
          value: "",
        },
        {
          type: "checkbox",
          name: "",
          placeHolder: "",
          value: false,
        },
      ],
    },
    {
      viewed: false,
      filled: false,
      fields: [
        {
          type: "verificationBtn",
          name: "OTP",
          placeHolder: "Enter Your OTP",
          value: "",
        },
      ],
    },
  ]);
  const [showOtpError, setShowOtpError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const registerAndGetOTP = (login_method = "sms") => {
    let category_id = Categories[Form[0].fields[0].value];
    let obj = {};
    if (category_id === "1" || category_id === "4") {
      obj = {
        level: Form[0].fields[1].value,
        stream_id: Form[0].fields[2].value,
        course: Form[0].fields[3].value,
        category_id: ["11th Class", "12th Class"].includes(Form[0].fields[1].value) ? "4" : "1",
      };
    } else {
      obj = {
        category_id,
        level: "Advanced Level",
        stream_id: Form[0].fields[1].value,
        course: Form[0].fields[2].value,
      };
    }
    obj = {
      ...obj,
      tutor_gender_preference: genderConversion[Form[1].fields[0].value],
      mode_of_tution: modeOfTutionconversion[Form[1].fields[1].value],
      days_per_week: Form[1].fields[2].value,
      when_to_start: Form[1].fields[3].value,

      first_name: Form[2].fields[0].value,
      last_name: Form[2].fields[1].value,
      gender: Form[2].fields[2].value,
      phone: Form[2].fields[3].value,
      email: Form[2].fields[4].value,
      reference: Form[2].fields[5].value,

      city_name: Form[1].fields[4].value,
      state_name: Form[1].fields[5].value.state,
      locality: Form[1].fields[5].value.locality,
      gmap_meta_data: Form[1].fields[5].value.gmap_meta_data,
      zip: Form[1].fields[5].value.pincode,
      latitude: Form[1].fields[5].value.latitude,
      longitude: Form[1].fields[5].value.longitude,
    };

    axios
      .post("v1/register", obj)
      .then(res => {
        return axios.post(`v1/generateOtp`, {
          phoneNo: obj.phone,
          login_method,
          user_type: "Student",
        });
        // if(res.data!=="User is already registered"){
        // }
        // else{
        //   navigate('/dashboard')
        // }
      })
      .then(data => {
        data = data.data;
        if (!data.is_success) {
          setShowOtpError(() => data.error.msg);
          return;
        }
        let otp = data.data.otp;
        // console.log(otp);
        setOtp(otp);
        if (login_method === "whatsapp") {
          // if otp is null or empty then it is sms otp
          const whatsappLink = `https://wa.me/917386936695?text=Log%20me%20in%20to%20Homeshiksha%20%3A%20H-${otp}`;
          setTimeout(() => {
            window.open(whatsappLink, "_blank");
          });
          checkForJWT("whatsapp", otp);
        }
      })
      .catch(err => {
        // console.log(err);
      });
  };

  const checkForJWT = (login_method, otp = "") => {
    let findTokenInterval = setInterval(() => {
      getJWT(findTokenInterval, login_method, otp);
    }, 3000);
    setTimeout(
      () => {
        // console.log("Stoped verifing otp");
        clearInterval(findTokenInterval);
        setVerificationProcess(false);
      },
      2 * 60 * 1000,
    );
  };

  const getJWT = async (tokenInterval, login_method, otp) => {
    // console.log("finding token ...", tokenInterval);
    try {
      // console.log({ phoneNo: Form[2].fields[3].value, otp: otp, login_method });
      let data = await axios.post(`v1/generateJWT`, {
        phoneNo: Form[2].fields[3].value,
        otp: otp,
        login_method,
      });
      // console.log(data.data);
      if (!data.data.is_success) return;
      localStorage.setItem("homeshiksha-jwt", JSON.stringify(data.data.data.token));
      localStorage.setItem("paymentPopUp", JSON.stringify(true));
      clearInterval(tokenInterval);
      setVerificationProcess(false);
      navigate("/dashboard");
      window.location.reload();
    } catch (error) {
      // console.log(error);
    }
    // stopFindingJWT()
  };

  const fetchCourses = useCallback(
    (catId, courseLevel = "") => {
      axios
        .get("v1/student/all-courses?category_id=" + Categories[catId])
        .then(response => {
          let dataFromAPI = response.data;
          setApiData(() => dataFromAPI);
          let _streamsList = dataFromAPI.map(itm => itm.stream_name);
          let _addedFields = [];
          const coursesList = dataFromAPI[0].courses.sort((a, b) => a.length - b.length);
          switch (catId) {
            case "school education":
              _addedFields.push({
                type: "dropDown",
                open: courseLevel === "",
                name: "For Which Class you need a Tutor ?",
                placeHolder: "For Which Class you need a Tutor ?",
                options: [
                  "Primary / Pre-Primary",
                  "LKG / UKG",
                  "1st Class",
                  "2nd Class",
                  "3rd Class",
                  "4th Class",
                  "5th Class",
                  "6th Class",
                  "7th Class",
                  "8th Class",
                  "9th Class",
                  "10th Class",
                  "11th Class",
                  "12th Class",
                ],
                value: courseLevel,
              });
              _addedFields.push({
                type: "dropDown",
                open: courseLevel !== "",
                name: "Choose the school board ?",
                placeHolder: "Choose the school board ?",
                options: _streamsList,
                value: "",
              });
              _addedFields.push({
                type: "dropDown-selection",
                open: false,
                name: "Course",
                placeHolder: "Select Your Course",
                options: coursesList,
                value: [],
              });
              break;
            case "Intermediate Courses":
              _addedFields.push({
                type: "dropDown",
                open: courseLevel === "",
                name: "For Which Class you need a Tutor ?",
                placeHolder: "For Which Class you need a Tutor ?",
                options: [
                  "Primary / Pre-Primary",
                  "LKG / UKG",
                  "1st Class",
                  "2nd Class",
                  "3rd Class",
                  "4th Class",
                  "5th Class",
                  "6th Class",
                  "7th Class",
                  "8th Class",
                  "9th Class",
                  "10th Class",
                  "11th Class",
                  "12th Class",
                ],
                value: courseLevel,
              });
              _addedFields.push({
                type: "dropDown",
                open: courseLevel !== "",
                name: "Choose the school board ?",
                placeHolder: "Choose the school board ?",
                options: _streamsList,
                value: "",
              });
              _addedFields.push({
                type: "dropDown-selection",
                open: false,
                name: "Course",
                placeHolder: "Select Your Course",
                options: coursesList,
                value: [],
              });
              break;
            case "Learn Language":
              _addedFields.push({
                type: "dropDown",
                open: true,
                name: "Stream",
                placeHolder: "Select Your Stream",
                options: _streamsList,
                value: "",
              });
              _addedFields.push({
                type: "dropDown-selection",
                open: false,
                name: "Course",
                placeHolder: "Select Your Course",
                options: coursesList,
                value: [],
              });
              break;
            case "Curricular":
              _addedFields.push({
                type: "dropDown",
                open: true,
                name: "Stream",
                placeHolder: "Select Your Stream",
                options: _streamsList,
                value: "",
              });
              _addedFields.push({
                type: "dropDown-selection",
                open: false,
                name: "Course",
                placeHolder: "Select Your Course",
                options: coursesList,
                value: [],
              });
              break;
            case "Competitive Exams":
              _addedFields.push({
                type: "dropDown",
                open: true,
                name: "Exam",
                placeHolder: "Select Your Exam",
                options: _streamsList,
                value: "",
              });

              _addedFields.push({
                type: "dropDown-selection",
                open: false,
                name: "Course",
                placeHolder: "Select Your Course",
                options: coursesList,
                value: [],
              });
              break;
            case "Special Kids (ADHD /ADD /AUTISM)":
              _addedFields.push({
                type: "dropDown",
                open: true,
                name: "Child Age group",
                placeHolder: "Child Age group",
                options: _streamsList,
                value: "",
              });

              _addedFields.push({
                type: "dropDown-selection",
                open: false,
                name: "Course",
                placeHolder: "Select Your Course",
                options: coursesList,
                value: [],
              });
              break;
            case "IT Courses":
              _addedFields.push({
                type: "dropDown",
                open: false,
                name: "Stream",
                placeHolder: "Select Your Stream",
                options: _streamsList,
                value: _streamsList[0],
              });
              _addedFields.push({
                type: "dropDown-selection",
                open: true,
                name: "Course",
                placeHolder: "Select Your Course",
                options: coursesList,
                value: [],
              });
              break;
            default:
              return;
          }
          setForm(pre => {
            let _Form = [...pre];
            _Form[0].fields = [_Form[0].fields[0], ..._addedFields];
            return _Form;
          });

          setEnableSubmitButton(() => true);
        })
        .catch(err => {});
    },
    [setApiData, setForm],
  );

  const makeTitle = string => {
    try {
      let arr = string.split(" ");
      arr = arr.map(itm => itm.charAt(0).toUpperCase() + itm.slice(1));
      return arr.join(" ");
    } catch (error) {
      return string;
    }
  };

  const handleWhatsAppLogin = e => {
    e.preventDefault();
    setVerificationProcess(true);
    registerAndGetOTP("whatsapp");
    logEvent(EVENTS.WHATSAPP_REGISTER.event_name);
  };

  const handleVerifyBySMS = () => {
    setSmsOtpVerification(() => true);
    setVerificationProcess(() => true);
    registerAndGetOTP("sms");
    setTimeout(
      () => {
        setShowResendOtp(() => true);
      },
      2 * 60 * 1000,
    );
    logEvent(EVENTS.SMS_REGISTER.event_name);
  };

  const handleOtpChange = e => {
    let otp = e.target.value;
    setOtp(() => otp);
    if (otp.length === 6) {
      setVerificationProcess(() => true);
      axios
        .post(`v1/verifyOtp`, {
          phoneNo: Form[2].fields[3].value,
          otp: otp,
        })
        .then(data => {
          // console.log(data.data);
          checkForJWT("sms", otp);
        })
        .catch(err => {
          // console.log(err);
        });
    } else {
      setVerificationProcess(() => false);
    }
  };

  const handledropDownOptionClick = useCallback(
    (field, index, step, option) => {
      setForm(prevForm => {
        const newForm = [...prevForm];
        newForm[step].viewed = true;
        newForm[step].fields[index].value = option;

        if (field.name === "Choose Study Area") {
          fetchCourses(option);
        }
        if (field.name === "For Which Class you need a Tutor ?") {
          if (
            [
              "Primary / Pre-Primary",
              "LKG / UKG",
              "1st Class",
              "2nd Class",
              "3rd Class",
              "4th Class",
              "5th Class",
              "6th Class",
              "7th Class",
              "8th Class",
              "9th Class",
              "10th Class",
            ].includes(option)
          )
            fetchCourses("school education", option);
          else fetchCourses("Intermediate Courses", option);
        }
        if (
          ["Choose the school board ?", "Choose the college board ?", "Child Age group", "Stream", "Exam"].includes(
            field.name,
          )
        ) {
          const _courseList = apiData.find(dataField => dataField.stream_name === option);
          newForm[step].fields[index + 1].open = true;
          newForm[step].fields[index + 1].options = _courseList.courses.sort((a, b) => a.length - b.length);
        }

        try {
          if (newForm[step].fields[index + 1].type === "dropDown" && newForm[step].fields[index + 1].value === "") {
            newForm[step].fields[index + 1].open = true;
          }
        } catch (error) {
          // console.log("Error occurred:", error);
        }

        return newForm;
      });
    },
    [apiData, fetchCourses, setForm],
  );

  const handledropDownSelectOptionClick = (field, index, step, option, status) => {
    setForm(prevForm => {
      const newForm = [...prevForm];
      newForm[step].viewed = true;
      const optionIndxInValueArray = newForm[step].fields[index].value.indexOf(option);
      try {
        if (optionIndxInValueArray === -1 && !status) {
          newForm[step].fields[index].value.push(option);
        } else if (optionIndxInValueArray !== -1 && status) {
          newForm[step].fields[index].value.splice(optionIndxInValueArray, 1);
        }
        if (newForm[step].fields[index + 1].type === "dropDown" && newForm[step].fields[index + 1].value === "") {
          newForm[step].fields[index + 1].open = true;
        }
      } catch (error) {}

      return newForm;
    });
  };

  const Step = step => (
    <div className="form--container">
      <form
        onSubmit={e => {
          e.preventDefault();
          let newForm = [...Form];
          let emptyField = [];
          newForm[step].fields.map(inpurField => {
            if (inpurField.value.length === 0) emptyField.push(inpurField.name);
            if (inpurField.name == "Mobile") {
              logEvent(EVENTS.GIVEN_MOBILE_NO.event_name, inpurField.value);
              if (inpurField.value.length !== 10) emptyField.push(inpurField.name);
            }
            return inpurField;
          });
          if (emptyField.length === 0) {
            logEvent(EVENTS["HS_STEP_NO_" + (step + 1)].event_name);
            setCurrentStep(pre => step + 1);
            setForm(pre => {
              newForm[step].filled = true;
              newForm[step + 1].viewed = true;
              try {
                if (newForm[step + 1].fields[0].type === "dropDown" && newForm[step + 1].fields[0].value === "") {
                  newForm[step + 1].fields[0] = {
                    ...newForm[step + 1].fields[0],
                    open: true,
                  };
                }
              } catch (error) {
                // console.log("error");
              }

              return newForm;
            });
          } else {
            setForm(pre => {
              newForm[step].fields = newForm[step].fields.map(inputField => {
                if (inputField.value === "") return { ...inputField, open: true };
                return inputField;
              });
              return newForm;
            });
          }
          window.scrollTo({ top: 0, behavior: "smooth" });
        }}>
        {Form[step].fields.map((field, index, stepArray) => {
          let options = field.options;
          if (field.name === "Stream") {
            options = options.reverse();
          }
          let formComponent = <div>input failed </div>;
          switch (field.type) {
            case "dropDown":
              formComponent = (
                <div
                  className="selection--wrapper"
                  onClick={e => {
                    setForm(pre => {
                      let newForm = [...pre];
                      newForm[step].fields[index] = {
                        ...field,
                        open: !field.open,
                      };
                      return newForm;
                    });
                  }}
                  onChange={e => {
                    if (!e.target.value) return;
                    handledropDownOptionClick(field, index, step, e.target.value);
                  }}>
                  {field.open ? (
                    options.map((option, optionIndex) => (
                      <div
                        key={`${field.name}-${optionIndex}`}
                        className={`selection--option-wrapper ${field.open ? "showDropdown" : "hideDropdown"}`}>
                        <input
                          type="radio"
                          id={`${field.name}-${optionIndex}`} // Ensure unique IDs for each radio button
                          value={option}
                          checked={option === field.value}
                          name={field.name}
                          required
                          style={{ cursor: "pointer" }}
                        />
                        <label
                          htmlFor={`${field.name}-${optionIndex}`}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            handledropDownOptionClick(field, index, step, option);
                          }}>
                          {makeTitle(option)}
                        </label>
                      </div>
                    ))
                  ) : field.value !== "" ? (
                    <div className={`selection--option-wrapper`}>
                      <input type="radio" readOnly={true} checked onChange={() => {}} />
                      {makeTitle(field.value)}
                    </div>
                  ) : (
                    field.placeHolder
                  )}
                </div>
              );
              break;
            case "dropDown-selection":
              let coursesList = field.options;
              if (stepArray[1].name === "For Which Class you need a Tutor ?") {
                if (["Primary / Pre-Primary", "LKG / UKG"].includes(stepArray[1].value)) coursesList = ["All Subjects"];
                else if (
                  ["1st Class", "2nd Class", "3rd Class", "4th Class", "5th Class", "6th Class", "7th Class"].includes(
                    stepArray[1].value,
                  )
                ) {
                  coursesList = coursesList.filter(
                    course =>
                      ![
                        "All Subjects",
                        "All Subjects Except Language",
                        "Physics",
                        "Chemistry",
                        "Biology",
                        "History",
                        "Geography",
                        "Political Science",
                      ].includes(course),
                  );
                  coursesList = ["All Subjects", "All Subjects Except Language", ...coursesList];
                } else if (["8th Class", "9th Class", "10th Class"].includes(stepArray[1].value))
                  coursesList = coursesList.filter(
                    course => !["All Subjects", "All Subjects Except Language"].includes(course),
                  );
                else if (["11th Class", "12th Class"].includes(stepArray[1].value))
                  coursesList = coursesList.filter(course => !["Science", "Accountancy"].includes(course));
              }
              formComponent = (
                <div className="selection--wrapper">
                  {field.open ? (
                    coursesList.map((option, optionIndex) => (
                      <div
                        key={`${field.name}-${optionIndex}`}
                        className={`selection--option-wrapper ${field.open ? "showDropdown" : "hideDropdown"}`}>
                        <input
                          type="checkbox"
                          id={`${field.name}-${optionIndex}`} // Ensure unique IDs for each radio button
                          value={option}
                          checked={field.value.includes(option)}
                          name={field.name}
                          // required
                          onChange={e => {
                            if (e.target.value)
                              handledropDownSelectOptionClick(
                                field,
                                index,
                                step,
                                e.target.value,
                                field.value.includes(option),
                              );
                          }}
                          style={{ cursor: "pointer" }}
                        />
                        <label htmlFor={`${field.name}-${optionIndex}`} style={{ cursor: "pointer" }}>
                          {makeTitle(option)}
                        </label>
                      </div>
                    ))
                  ) : !field.value ? (
                    <div className={`selection--option-wrapper`}>
                      <input type="radio" readOnly={true} />
                      {field.value.map(opt => makeTitle(opt))}
                    </div>
                  ) : (
                    field.placeHolder
                  )}
                </div>
              );
              break;
            case "address":
              formComponent = (
                <div>
                  <Autocomplete
                    apiKey={apiKey}
                    style={{ width: "99%" }}
                    onPlaceSelected={place => {
                      let addressComponents = place.address_components;
                      let pinCode = addressComponents.find(component => component.types.includes("postal_code"));
                      let locality = addressComponents.map(geo => geo.long_name).join(", ");
                      let city = addressComponents.find(
                        component => component.types.includes("locality") && component.types.includes("political"),
                      );
                      let state = addressComponents.find(
                        component =>
                          component.types.includes("administrative_area_level_1") &&
                          component.types.includes("political"),
                      );
                      let latitude = place.geometry.location.lat();
                      let longitude = place.geometry.location.lng();
                      let value = {
                        pincode: pinCode ? pinCode.short_name : " ",
                        city: city ? city.long_name : " ",
                        state: state ? state.long_name : " ",
                        locality: locality,
                        latitude: latitude,
                        longitude: longitude,
                        gmap_meta_data: JSON.stringify(addressComponents),
                      };
                      logEvent(EVENTS.GIVEN_PINCODE.event_name);

                      setForm(pre => {
                        let newForm = [...pre];
                        newForm[step].viewed = true;
                        newForm[step].fields[index] = {
                          ...field,
                          value: value,
                        };
                        return newForm;
                      });
                    }}
                    options={{
                      types: [
                        // "hospital",
                        // "pharmacy",
                        // "bakery",
                        // "sublocality",
                        // ,
                        // "landmark",
                        // "locality",
                        // "postal_code",
                        // "postal_code_prefix",
                        // "postal_code_suffix",
                        // "postal_town",
                        // "street_address",
                        // "street_number",
                        // "sublocality",
                        // "sublocality_level_1",
                        // "sublocality_level_2",
                        // "sublocality_level_3",
                        // "sublocality_level_4",
                        // "sublocality_level_5",
                        // "subpremise",
                        // "town_square",
                      ],
                      componentRestrictions: { country: "IN" }, // Set country to "IN" for India
                    }}
                    placeholder={field.placeHolder}
                  />
                </div>
              );
              break;
            case "verificationBtn":
              if (!smsOtpVerification) {
                formComponent = (
                  <div>
                    <div className="login-btns-wrapper register-btns-wrapper" id="whatsapp-login-btn">
                      <button
                        type="button"
                        className="registerPrimaryButton"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        onClick={e => {
                          handleWhatsAppLogin(e);
                        }}>
                        <img src="/whatsapp-icon.svg" alt="whats app icon" /> Verify with Whatsapp
                      </button>
                      <img
                        src="/book-loader.gif"
                        style={{ width: "auto" }}
                        alt=" Loading . . .  "
                        className={`${verificationProcess ? "" : "in"}active-img`}
                      />
                    </div>
                    <div className="login-btns-wrapper register-btns-wrapper">
                      <button
                        type="button"
                        className="registerPrimaryButton"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        onClick={e => {
                          handleVerifyBySMS();
                        }}>
                        Verify with Mobile SMS
                      </button>
                      <img
                        src="/book-loader.gif"
                        style={{ width: "auto" }}
                        alt=" Loading . . .  "
                        className={`${verificationProcess ? "in" : "in"}active-img`}
                      />
                    </div>
                  </div>
                );
              } else {
                formComponent = (
                  <>
                    <div className="input-loading-wrapper" style={{ flexDirection: "column" }}>
                      {showOtpError && <div className="errorAlert">{showOtpError} </div>}
                      <input
                        type="tel"
                        placeholder="Enter your OTP"
                        className="loginInputField"
                        value={otp}
                        onChange={e => {
                          handleOtpChange(e);
                        }}
                        style={{ textAlign: "center" }}
                      />
                      <div className="genetating-otp-loader">
                        {verificationProcess && <img src="/book-loader.gif" alt=" Loading . . .  " />}
                      </div>
                    </div>
                    <div className="login-btns-wrapper">
                      <div>
                        {showResendOtp && (
                          <button
                            type="button"
                            className="loginPrimaryButton"
                            onClick={() => {
                              handleVerifyBySMS();
                            }}>
                            Resend OTP
                          </button>
                        )}
                      </div>
                    </div>
                  </>
                );
              }
              break;
            case "checkbox":
              formComponent = (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}>
                  <input
                    required
                    type={field.type}
                    id={`${field.name}`}
                    name={`${field.name}`}
                    placeholder={`${field.placeHolder}`}
                    value={field.value}
                    onChange={e => {
                      let value = !field.value;
                      setForm(pre => {
                        let newForm = [...pre];
                        newForm[step].viewed = true;
                        newForm[step].fields[index] = {
                          ...field,
                          value: value,
                        };
                        return newForm;
                      });
                    }}
                  />
                  <span style={{ marginLeft: "8px", fontWeight: "600" }}>
                    I have read and accept{" "}
                    <span
                      onClick={() => {
                        const url = location.pathname.endsWith("/shadow")
                          ? "https://shadow.homeshiksha.com/?page_id=402"
                          : "https://homeshiksha.com/parents-terms-and-conditions/";
                        window.open(url, "_blank");
                      }}
                      style={{
                        color: "navy",
                        fontSize: "18px",
                        cursor: "pointer",
                      }}>
                      Student Terms and Conditions.
                    </span>
                  </span>
                </div>
              );
              break;
            default:
              formComponent = (
                <input
                  required
                  type={field.type}
                  id={`${field.name}`}
                  name={`${field.name}`}
                  placeholder={`${field.placeHolder}`}
                  value={field.value}
                  maxLength={field.name === "Mobile" ? 10 : undefined}
                  minLength={field.name === "Mobile" ? 10 : undefined}
                  pattern={field.name === "Mobile" ? "^[0-9]{10}$" : undefined}
                  inputMode={field.name === "Mobile" ? "numeric" : undefined}
                  autoComplete={field.name === "Mobile" ? "tel" : undefined}
                  onChange={e => {
                    let value = e.target.value;

                    if (field.type === "tel" || field.name === "Mobile") {
                      value = value.replace(/\D/g, "");
                      if (value.length > 10) return;
                    }

                    setForm(pre => {
                      let newForm = [...pre];
                      newForm[step].viewed = true;
                      newForm[step].fields[index] = {
                        ...field,
                        value: value,
                      };
                      return newForm;
                    });
                  }}
                />
              );
          }

          return (
            <div key={index}>
              <div className="input-group">
                <label htmlFor={`${field.name}`}>{!field.open ? field.name : field.placeHolder}</label>
                {formComponent}
              </div>
            </div>
          );
        })}

        <div className="form-buttons-wrapper">
          {currentStep > 0 && currentStep < 3 && (
            <button className="secondary-btn" type="button" onClick={e => setCurrentStep(step - 1)}>
              Previous
            </button>
          )}
          {currentStep < 3 && (
            <button className="primary-btn" type="submit" disabled={!enableSubmitButton}>
              Next
            </button>
          )}
          {/* {currentStep === 5 && <button className="primary-btn" type="button">Save</button>} */}
        </div>
      </form>
    </div>
  );

  useEffect(() => {
    let jwt = JSON.parse(localStorage.getItem("homeshiksha-jwt"));
    if (!jwt) {
      localStorage.setItem("userDetails", JSON.stringify({}));
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/dashboard");
      window.location.reload();
    }
  }, []);

  // Auto-select 'Special Kids (ADHD /ADD /AUTISM)' if on /need-a-tutor/shadow
  useEffect(() => {
    if (location.pathname.endsWith("/shadow")) {
      setForm(prevForm => {
        const newForm = [...prevForm];
        newForm[0].fields[0].options = ["Special Kids (ADHD /ADD /AUTISM)"];
        newForm[0].fields[0].value = "Special Kids (ADHD /ADD /AUTISM)";
        return newForm;
      });
      fetchCourses("Special Kids (ADHD /ADD /AUTISM)");
    } else {
      setForm(prevForm => {
        const newForm = [...prevForm];
        newForm[0].fields[0].options = [
          "school education",
          "Learn Language",
          "Curricular",
          "Competitive Exams",
          // 'Intermediate Courses',
          // 'Abroad Exams',
          "IT Courses",
          "Special Kids (ADHD /ADD /AUTISM)",
        ];
        return newForm;
      });
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  return (
    <>
      <main className="main need-a-tutor">
      <section className="top-session">
        <div className="need-a-tutor-top-session--rightpart-wrapper">
          <div className="need-a-tutor-top-session--rightpart--form-wrapper">
            <div className="form_title">Find Your Tutor</div>
            <div className="form-status--wrapper">
              <div className="steps-wrapper">
                {Form.map((item, index) => (
                  <div className="step-status-wrapper" key={index}>
                    <div
                      onClick={e => {
                        if (Form[index].viewed) setCurrentStep(pre => index);
                      }}>
                      Step {index + 1}{" "}
                    </div>
                    <div
                      onClick={e => {
                        if (Form[index].viewed) setCurrentStep(pre => index);
                      }}
                      className={`step-status-circle ${Form[index].viewed ? "blue-border" : ""} ${
                        Form[index].filled ? "blue-bg" : ""
                      }`}></div>
                  </div>
                ))}
              </div>
              <div className="line-wrapper-under-steps-wrapper"></div>
            </div>
            <div className="form--wrapper">{Step(currentStep)}</div>
          </div>
        </div>
        <div className="need-a-tutor-top-session--leftpart-wrapper">
          <div className="need-a-tutor-biglogo--wrapper">
            <img src="/need-tutor-form-side-img-2025-10-28.png" alt="main-pic-in-register-page pic" />
            <div className="need-a-tutor-biglogo--title">
              Elevating <span style={{ color: "rgba(43, 147, 165, 1)" }}>Education</span>,
              <br /> One <span style={{ color: "rgba(43, 147, 165, 1)" }}>Home</span> at a Time
            </div>
          </div>
        </div>
      </section>

      <PlatformReviewComponent></PlatformReviewComponent>

      <section className="small-section">
        <div className="small-section--text">
          <div className="small-section--text-left"></div>
        </div>
      </section>

      <section className="endorsed-and-certified-section">
        <div className="endorsed-and-certified-section--imgs-wrapper">
          <div className="endorsed-by-india-section-section-left-text">
            <h1 className="text-top">We are now incubated</h1>
            <h1 className="text-middle">with</h1>
            <h1 className="text-city">IIM Bangalore</h1>
          </div>
          <div className="endorsed-by-india-section-section-right-img">
            <img src="/iimb-logo.png" alt="msme img" className="img-2" />
          </div>
        </div>
      </section>

      <section className="certified-by-india-section">
        <div className="certified-by-india-section--title">Certified by Indian Government</div>
        {/* <div className="certified-by-india-section--midline"></div> */}
        <div className="certified-by-india-section--imgs-wrapper">
          <div>
            <img src="/MSME-need-a-tutor.svg" alt="msme img" className="img-3" />
          </div>
          <div>
            <img src="/startup-India.svg" alt="start up india img" className="img-4" />
          </div>
        </div>
      </section>

      <section className="small-section">
        <div className="section-title-why-choose-us">
          Why To Choose <span className="highlight">HomeShiksha</span>
        </div>

        {/* 
        <div className="small-section--text-left--text" >
          Get home/online tutors for dancing, singing, painting, foreign language, motivation faculty, disabled children and co-curricular activities.
        </div> */}

        <div className="small-section--text">
          <div className="small-section--text-left">
            <div>
              <div className="small-section--text-left--text-icon">
                <img src="/points-tic-icon-2025-04-12.svg" style={{ width: "20px" }} alt="points-tic-icon" />
                <div className="small-section--text-left--text-font">Get Free Demo Class</div>
              </div>
            </div>

            <div>
              <div className="small-section--text-left--text-icon">
                <img src="/points-tic-icon-2025-04-12.svg" style={{ width: "20px" }} alt="points-tic-icon" />
                <div className="small-section--text-left--text-font">Get Female Tutors for Female Candidates.</div>
              </div>
            </div>
            <div>
              <div className="small-section--text-left--text-icon">
                <img src="/points-tic-icon-2025-04-12.svg" style={{ width: "20px" }} alt="points-tic-icon" />
                <div className="small-section--text-left--text-font">
                  Wide Range of tutors Available for all academic and non-academic categories
                </div>
              </div>
            </div>

            <div>
              <div className="small-section--text-left--text-icon">
                <img src="/points-tic-icon-2025-04-12.svg" style={{ width: "20px" }} alt="points-tic-icon" />
                <div className="small-section--text-left--text-font">Enjoy free tutor replacements whenever needed</div>
              </div>
            </div>
            <div>
              <div className="small-section--text-left--text-icon">
                <img src="/points-tic-icon-2025-04-12.svg" style={{ width: "20px" }} alt="points-tic-icon" />
                <div className="small-section--text-left--text-font">Cost Effective Options</div>
              </div>
            </div>
            <div>
              <div className="small-section--text-left--text-icon">
                <img src="/points-tic-icon-2025-04-12.svg" style={{ width: "20px" }} alt="points-tic-icon" />
                <div className="small-section--text-left--text-font">
                  Get a dedicated Relationship manager for all tuition needs
                </div>
              </div>
            </div>
            <div>
              <div className="small-section--text-left--text-icon">
                <img src="/points-tic-icon-2025-04-12.svg" style={{ width: "20px" }} alt="points-tic-icon" />
                <div className="small-section--text-left--text-font">
                  Specialised educators and shadow teachers for ADHD, Dyslexia, and Autism, delivering personalised
                  support.
                </div>
              </div>
            </div>
          </div>
          <div className="second-main-pic-wrapper">
            <img src="/whychoose-icon-2025-04-12.svg" className="second-main-pic" alt="second-main-pic" />
          </div>
        </div>
      </section>

      <section className="small-section">
        <div className="video-container">
          <iframe
            width="100%"
            height="600px"
            src="https://www.youtube.com/embed/9pzHKztmOqg?si=qqqpfqtdBKp3KyGZ"
            title="Welcome to Homeshiksha"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen></iframe>
        </div>
      </section>

      {/* <section className="small-section">k
        <div className="small-blue-border"></div>
        <div className="small-section--text">
          <div className="small-section--text-left">
            <div className="small-section--text-left--title">How it works?</div>
            <div>
              HomeShiksha is the leading provider of private tutoring.We are
              rapidly growing organisation that offers huge possibilities for
              your career advancement.
            </div>
          </div>
          <div className="small-section--text-right">
            HomeShiksha has a mission to make world class home-tuitions, online
            tuitions and e-tuitions accessible and dedicated to fulfill dreams
            of education across India.We help find learning options for students
            as well as adults in academic and non academic area.
          </div>
        </div>
      </section> */}
      {/* <section className="how-it-works--wrapper">
        <div className="how-it-works-parts">
          <div className="how-it-works-step--wrapper">
            <div className="how-it-works-step--image-wrapper">
              <div
                className="how-it-works-step--image--container"
                style={{ backgroundColor: "rgba(255, 236, 221, 1)" }}
              >
                <img src="/step-1-icon.svg" alt="step-1-icon pic" />
                <img
                  className="how-it-works-step--curve--image down-curve"
                  src="/down-curve-arrow.svg"
                  alt="down-curve-arrow"
                />
              </div>
            </div>
            <div className="how-it-works-step--content--container">
              <div className="step-no">01</div>
              <div className="step-title">Step</div>
              <div className="step-desc">Give your Requirements</div>
            </div>
          </div>

          <div className="how-it-works-step--wrapper">
            <div className="how-it-works-step--content--container">
              <div className="step-no">02</div>
              <div className="step-title">Step</div>
              <div className="step-desc">
                DOORSTEP/ONLINE Our executive will provide the expert online
                tutor or home tutor at your doorstep for free.
              </div>
            </div>
            <div className="how-it-works-step--image-wrapper">
              <div
                className="how-it-works-step--image--container"
                style={{ backgroundColor: "rgba(148, 222, 244, 1)" }}
              >
                <img src="/step-2-icon.svg" alt="step-2-icon pic" />
                <img
                  className="how-it-works-step--curve--image up-curve"
                  src="/up-curve-arrow.svg"
                  alt="up-curve-arrow pic"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="how-it-works-parts">
          <div className="how-it-works-step--wrapper">
            <div className="how-it-works-step--image-wrapper">
              <div
                className="how-it-works-step--image--container"
                style={{ backgroundColor: "rgba(148, 222, 244, 1)" }}
              >
                <img src="/step-3-icon.svg" alt="step-3-icon pic" />
                <img
                  className="how-it-works-step--curve--image down-curve"
                  src="/down-curve-arrow.svg"
                  alt="down-curve-arrow"
                />
              </div>
            </div>
            <div className="how-it-works-step--content--container">
              <div className="step-no">03</div>
              <div className="step-title">Step</div>
              <div className="step-desc">
                FREE DEMO Take free demo class from our expert/verified tutors
              </div>
            </div>
          </div>

          <div className="how-it-works-step--wrapper">
            <div className="how-it-works-step--content--container">
              <div className="step-no">04</div>
              <div className="step-title">Step</div>
              <div className="step-desc">
                CONFIRM Choose the expert tutor and start the tuition and be
                free from your worries...
              </div>
            </div>
            <div className="how-it-works-step--image-wrapper">
              <div
                className="how-it-works-step--image--container"
                style={{ backgroundColor: "rgba(230, 191, 244, 1)" }}
              >
                <img src="/step-4-icon.svg" alt="step-4-icon pic" />
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* <section className="how-it-works--wrapper">
        <div className="how-it-works-parts">
          <div className="how-it-works-step--wrapper">
            <div className="how-it-works-step--image-wrapper">
              <div
                className="how-it-works-step--image--container"
                style={{ backgroundColor: "rgba(255, 236, 221, 1)" }}
              >
                <img src="./step-1-icon.svg" alt="step-1-icon pic" />
                <img
                  className="how-it-works-step--curve--image down-curve"
                  src="./down-curve-arrow.svg"
                  alt="down-curve-arrow"
                />
              </div>
            </div>
            <div className="how-it-works-step--content--container">
              <div className="step-no">01</div>
              <div className="step-title">Step</div>
              <div className="step-desc">Give your Requirements</div>
            </div>
          </div>

          <div className="how-it-works-step--wrapper">
            <div className="how-it-works-step--content--container">
              <div className="step-no">02</div>
              <div className="step-title">Step</div>
              <div className="step-desc">
                DOORSTEP/ONLINE Our executive will provide the expert online
                tutor or home tutor at your doorstep for free.
              </div>
            </div>
            <div className="how-it-works-step--image-wrapper">
              <div
                className="how-it-works-step--image--container"
                style={{ backgroundColor: "rgba(148, 222, 244, 1)" }}
              >
                <img src="./step-2-icon.svg" alt="step-2-icon pic" />
                <img
                  className="how-it-works-step--curve--image up-curve"
                  src="./up-curve-arrow.svg"
                  alt="up-curve-arrow pic"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="how-it-works-parts">
          <div className="how-it-works-step--wrapper">
            <div className="how-it-works-step--image-wrapper">
              <div
                className="how-it-works-step--image--container"
                style={{ backgroundColor: "rgba(148, 222, 244, 1)" }}
              >
                <img src="./step-3-icon.svg" alt="step-3-icon pic" />
                <img
                  className="how-it-works-step--curve--image down-curve"
                  src="./down-curve-arrow.svg"
                  alt="down-curve-arrow"
                />
              </div>
            </div>
            <div className="how-it-works-step--content--container">
              <div className="step-no">03</div>
              <div className="step-title">Step</div>
              <div className="step-desc">
                FREE DEMO Take free demo class from our expert/verified tutors
              </div>
            </div>
          </div>

          <div className="how-it-works-step--wrapper">
            <div className="how-it-works-step--content--container">
              <div className="step-no">04</div>
              <div className="step-title">Step</div>
              <div className="step-desc">
                CONFIRM Choose the expert tutor and start the tuition and be
                free from your worries...
              </div>
            </div>
            <div className="how-it-works-step--image-wrapper">
              <div
                className="how-it-works-step--image--container"
                style={{ backgroundColor: "rgba(230, 191, 244, 1)" }}
              >
                <img src="./step-4-icon.svg" alt="step-4-icon pic" />
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* <section className="small-section">
        {/* <div className="small-blue-border"></div> */}
      {/* <div className="small-section--text">
          <div className="small-section--text-left">
            <div className="small-section--text-left--title">How it works? </div>
            <div>
              HomeShiksha is the leading provider of private tutoring.We are
              rapidly growing organisation that offers huge possibilities for
              your career advancement.
            </div>
          </div> */}

      {/* </div> */}
      {/* </section> */}

      <section className="small-section">
        <div className="section-title">
          How it <span className="highlight">Works</span>
        </div>
      </section>

      <section className="Image_ICON_Container">
        <img src="/ICON.svg" className="ICON_FLEX" alt="how-it-works" />
      </section>

      <section className="Image_ICON_Container_Large">
        <img src="/How-It-Works.svg" className="ICON_FLEX_Large" alt="how-it-works" />
      </section>

      <section className="Image_ICON_Container_Small">
        <img src="/How-It-Works-Mobile-2025-10-31.svg" className="ICON_FLEX_Large_Small" alt="how-it-works" />
      </section>
      {/* <section className="how-it-works--wrapper">
       */}
      {/* <div className="how-it-works-parts">
          <div className="how-it-works-step--wrapper">
            <div className="how-it-works-step--image-wrapper">
              <div
                className="how-it-works-step--image--container"
                style={{ backgroundColor: "rgba(255, 236, 221, 1)" }}
              >
                <img src="./step-1-icon.png" alt="step-1-icon pic" />
                <img
                  className="how-it-works-step--curve--image down-curve"
                  src="./down-curve-arrow.png"
                  alt="down-curve-arrow"
                />
               
              </div>
             
            </div>
            <div className="how-it-works-step--content--container">
              <div className="step-no">STEP 01</div>
              <div className="step-title">Submit Details</div>
              <div className="step-desc">callus/click on Need a Tutor to give your requirements</div>
            </div>
          </div>

          <div className="how-it-works-step--wrapper">
            <div className="how-it-works-step--content--container">
              <div className="step-no"> </div>
              <div className="step-title"></div>
              <div className="step-desc">
             
              </div>
            </div>
            <div className="how-it-works-step--image-wrapper-2">
              <div
                className="how-it-works-step--image--container"
                style={{ backgroundColor: "rgba(148, 222, 244, 1)" }}
              >
                <img src="./step-2-icon.png" alt="step-2-icon pic" />
                <img
                  className="how-it-works-step--curve--image up-curve"
                  src="./up-curve-arrow.png"
                  alt="up-curve-arrow pic"
                />
              </div>
            </div>
            <div className="how-it-works-step--content--container">
              <div className="step-no"> STEP 02</div>
              <div className="step-title">Instant Response</div>
              <div className="step-desc">
              HomeShiksha executive  will contact you within 1-2 working hours to discuss your needs...
              </div>
            </div>
          </div>
        </div>

        <div className="how-it-works-parts">
          <div className="how-it-works-step--wrapper">
            <div className="how-it-works-step--image-wrapper">
              <div
                className="how-it-works-step--image--container"
                style={{ backgroundColor: "rgba(148, 222, 244, 1)" }}
              >
                <img src="./step-3-icon.png" alt="step-3-icon pic" />
                <img
                  className="how-it-works-step--curve--image down-curve"
                  src="./down-curve-arrow.png"
                  alt="down-curve-arrow"
                />
              </div>
            </div>
            <div className="how-it-works-step--content--container">
              <div className="step-no">STEP 03</div>
              <div className="step-title">Free Demo</div>
              <div className="step-desc">
              Our HomeShiksha executive will provide the free demo class from our expert/verified tutors.
              </div>
            </div>
          </div>

          <div className="how-it-works-step--wrapper">
            <div className="how-it-works-step--content--container">
              <div className="step-no"></div>
              <div className="step-title"></div>
              <div className="step-desc-none">
          
              </div>
            </div>
            <div className="how-it-works-step--image-wrapper-4">
              <div
                className="how-it-works-step--image--container"
                style={{ backgroundColor: "rgba(230, 191, 244, 1)" }}
              >
                <img src="./step-4-icon.png" alt="step-4-icon pic" />
              </div>
            </div>

            <div className="how-it-works-step--content--container">
              <div className="step-no">STEP 04</div>
              <div className="step-title">Confirm</div>
              <div className="step-desc">
              Choose the expert tutor and start the tuition and be free from your worries
              </div>
            </div>
          </div>
        </div> */}
      {/* </section> */}

      <section className="small-section">
        <div className="section-title">
          Frequent asked <span className="highlight">Questions</span>
        </div>
      </section>

      <section className="FAQ_Container">
        <Faq data={FaqData} styles={styles} config={config} />
      </section>

      <SkilledTutorsComponent></SkilledTutorsComponent>

      <section className="small-section">
        <div className="section-title">
          Hear From Our <span className="highlight">Parents</span>
        </div>
      </section>

      <ParentsReviewComponent></ParentsReviewComponent>
    </main>
    <Footer />
  </>
  );
}
